import Swiper from 'swiper';
import Alpine from 'alpinejs';
import { Autoplay, Grid, Navigation } from 'swiper/modules';
import InitSwiperComponent from '../interfaces/InitSwiperComponent';

export default function initInformationSustainableCards() {
  Alpine.data(
    'informationSustainableCards',
    (): InitSwiperComponent => ({
      swiper: null,
      init() {
        // @ts-ignore
        const swiperEl = this.$el.querySelector('.sustainableCards-swiper');
        if (swiperEl) {
          this.initSwiper(swiperEl);
        }
      },
      initSwiper(domEl) {
        this.swiper = new Swiper(domEl, {
          modules: [Autoplay, Navigation, Grid],
          spaceBetween: 10,
          autoplay: {
            delay: 2500,
            disableOnInteraction: true,
          },
          grid: {
            rows: 3,
            fill: 'row',
          },
          slidesPerView: 6,
          slidesPerGroup: 6,
          navigation: {
            // @ts-ignore
            nextEl: `#${this.$el.id} .swiper-button-next`,
            // @ts-ignore
            prevEl: `#${this.$el.id} .swiper-button-prev`,
          },
          breakpoints: {
            0: {
              grid: { rows: 2 },
              slidesPerView: 2,
              slidesPerGroup: 2,
              spaceBetween: 12,
            },
            768: {
              grid: { rows: 2 },
              slidesPerView: 3,
              slidesPerGroup: 3,
            },
            1200: {
              grid: { rows: 3 },
              slidesPerView: 6,
              slidesPerGroup: 6,
            },
          },
        });
      },
    }),
  );
}
